// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1h6V8","content":"LoadingAlert_content__3FCRS"};